import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import  moment from 'moment';
moment.locale('ar');

@Pipe({
  name: 'gorgianDate'
})
export class GorgianDatePipe implements PipeTransform {

  transform(value: any, format: string = 'DD-MM-YYYY', lang: 'ar' | 'en' = 'en'): string {

    if (!value) return '';
  
    const gregorianMonthsArabic = [
      'يناير', 'فبراير', 'مارس', 'أبريل', 'مايو', 'يونيو',
      'يوليو', 'أغسطس', 'سبتمبر', 'أكتوبر', 'نوفمبر', 'ديسمبر'
    ];
  
    const gregorianMonthsLatin = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
  
    // Format the date according to the input format
    let date = moment(value).format(format);
  
    let [day, month, year] = date.split('-'); // Assuming the format is 'DD-MM-YYYY'
  
    // Define Arabic and Latin numerals
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    const latinNumerals = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  
    // If the language is Arabic, convert numerals to Arabic numerals
    if (lang === 'ar') {
      day = day.replace(/\d/g, (digit) => arabicNumerals[parseInt(digit, 10)]);
      year = year.replace(/\d/g, (digit) => arabicNumerals[parseInt(digit, 10)]);
    }
  
    // Convert the month number to 0-based index
    const monthIndex = parseInt(month, 10) - 1;
  
    // Ensure the monthIndex is within range
    if (monthIndex >= 0 && monthIndex <= 11) {
      month = lang === 'ar' ? gregorianMonthsArabic[monthIndex] : gregorianMonthsLatin[monthIndex];
    }
  
    return day + '-' + month + '-' + year;
  }

}
